import { render, staticRenderFns } from "./tempIndex.vue?vue&type=template&id=11a9aad2&scoped=true&"
import script from "./tempIndex.vue?vue&type=script&lang=js&"
export * from "./tempIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a9aad2",
  null
  
)

export default component.exports